import { ActionIcon } from '@mantine/core';

export const LegacyActionIcon = ActionIcon.withProps({ color: 'gray', variant: 'subtle' });
